/**
 * @generated SignedSource<<81d17ebb57548ac113a91c859a636764>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnitSchoolGradeEnum = "five" | "four" | "high" | "highest" | "low" | "lowest" | "medium" | "one" | "seven" | "six" | "three" | "two" | "zero" | "%future added value";
export type UnitSchoolGradeSelectField_unitQuery$variables = {
  id: string;
};
export type UnitSchoolGradeSelectField_unitQuery$data = {
  readonly unit: {
    readonly id: string;
    readonly schoolGrades: ReadonlyArray<UnitSchoolGradeEnum>;
  };
};
export type UnitSchoolGradeSelectField_unitQuery = {
  response: UnitSchoolGradeSelectField_unitQuery$data;
  variables: UnitSchoolGradeSelectField_unitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Unit",
    "kind": "LinkedField",
    "name": "unit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schoolGrades",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitSchoolGradeSelectField_unitQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitSchoolGradeSelectField_unitQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "42cc520b742581879627de9bfa46e07d",
    "id": null,
    "metadata": {},
    "name": "UnitSchoolGradeSelectField_unitQuery",
    "operationKind": "query",
    "text": "query UnitSchoolGradeSelectField_unitQuery(\n  $id: ID!\n) {\n  unit(id: $id) {\n    id\n    schoolGrades\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f218d8074be07692dce82a2c9ba7c99";

export default node;
